import { TraceableProcess, TrackingEvent } from '../../../services/analytics/model';

export class PublicationStarted implements TrackingEvent {
  public readonly action = 'Publication Started';
  public readonly category = TraceableProcess.AUTOPUBLISH;
  public readonly label = `User validates OTP and start the first step Autopub`;

  constructor(public readonly userId: string) {}
}
